import './App.css';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { endPrerenderedFirstLoad } from './components/motion/prerendered';
import Home from './pages/home/home';
import CaseStudy from './pages/caseStudy/caseStudy';
import caseStudies from './data/caseStudies';
import MoralRiskHealth from './pages/articles/moralRiskHealth/moralRiskHealth';
import AiDepressive from './pages/articles/aiDepressive/aiDepressive';

import Mlrolehealth from './pages/articles/mlrolehealth/mlrolehealth';
import ArticlesMain from './pages/articles/articlesMain/articlesMain';
import AiInArchitect from './pages/articles/aiInArchitect/aiInArchitect';
import MlOutRails from './pages/articles/mlOutRails/mlOutRails';
import MlEcommerce from './pages/articles/mlEcommerce/mlEcommerce';
import DigitalHealth from './pages/articles/digitalHealth/digitalHealth';
import AiChatbots from './pages/articles/aiChatbots/aiChatbots';
import MlRoadmap from './pages/articles/mlRoadmap/mlRoadmap';
import ComputerVision from './pages/articles/computerVision/computerVision';
import GenAi from './pages/articles/genAi/genAi';
import DataPrivacy from './pages/articles/dataPrivacy/dataPrivacy';
import ContactUs from './pages/contactUs/contactUs';

import OurProducts from './pages/ourProducts/ourProducts';
import AboutUs from './pages/aboutUs/aboutUs';
import AiReadiness from './pages/aiReadiness/aiReadiness';
import SeoCheck from './pages/seoCheck/seoCheck';
import AccessibilityCheck from './pages/accessibilityCheck/accessibilityCheck';
import AiSavings from './pages/aiSavings/aiSavings';
import Process from './pages/process/process';
import Estimator from './pages/estimator/estimator';
import Privacy from './pages/privacy/privacy';
import Services from './pages/services/services';
import ServiceDetail from './pages/services/serviceDetail';
import services from './data/services';
import Industries from './pages/industries/industries';
import IndustryDetail from './pages/industries/industryDetail';
import industries from './data/industries';
import ArticlePage from './pages/articles/articlePage/articlePage';
import articles from './data/articles';
import NotFound from './pages/notFound/notFound';
import LocaleUrlSync from './components/LanguageSwitcher/LocaleUrlSync';
import { LOCALIZED_LANGS, LOCALIZED_PATHS, localizedPath, splitLocale } from './config/i18nRoutes';

// The page component for a path that also has /de, /fr and /es versions.
const localizedElement = (base) => {
  if (base === '/') return <Home />
  if (base === '/services') return <Services />
  if (base === '/process') return <Process />
  if (base === '/about-us') return <AboutUs />
  if (base === '/contact-us') return <ContactUs />
  const service = services.find((item) => `/services/${item.slug}` === base)
  return service ? <ServiceDetail service={service} /> : null
}

function App() {
  return (
    <Router>
      <Content />
    </Router>
  );
}

function Content() {
  const location = useLocation();
  const pathName = splitLocale(location.pathname).base;

  // The prerendered HTML has been replaced by now; pages mounted from here on
  // animate in normally.
  useEffect(() => {
    endPrerenderedFirstLoad();
  }, []);

  return (
    <div className={`App ${pathName === '/' ? 'app-with-bg-img' : ''}`}>
      <LocaleUrlSync />
      <Routes>
        <Route path="/" element={<Home />} />
        {LOCALIZED_LANGS.flatMap((lang) =>
          LOCALIZED_PATHS.map((base) => (
            <Route key={`${lang}${base}`} path={localizedPath(base, lang)} element={localizedElement(base)} />
          ))
        )}
        {caseStudies.map((study) => (
          <Route key={study.slug} path={study.path} element={<CaseStudy study={study} />} />
        ))}
        <Route path="/services" element={<Services />} />
        {services.map((service) => (
          <Route key={service.slug} path={`/services/${service.slug}`} element={<ServiceDetail service={service} />} />
        ))}
        <Route path="/industries" element={<Industries />} />
        {industries.map((industry) => (
          <Route key={industry.slug} path={`/industries/${industry.slug}`} element={<IndustryDetail industry={industry} />} />
        ))}
        <Route path="/projects" element={<OurProducts />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/ai-readiness" element={<AiReadiness />} />
        <Route path="/seo-check" element={<SeoCheck />} />
        <Route path="/accessibility-check" element={<AccessibilityCheck />} />
        <Route path="/ai-savings" element={<AiSavings />} />
        <Route path="/process" element={<Process />} />
        <Route path="/estimate" element={<Estimator />} />
        <Route path="/privacy" element={<Privacy />} />


        

        
        

        {articles.map((article, index) => {
          const next = articles[index + 1]
          return (
            <Route
              key={article.slug}
              path={`/articles/${article.slug}`}
              element={<ArticlePage article={article} next={next ? { link: `/articles/${next.slug}`, slug: next.slug, title: next.title } : null} />}
            />
          )
        })}
        <Route path="/articles/mlrolehealth" element={<Mlrolehealth />} />
        <Route path="/articles/moralRiskHealth" element={<MoralRiskHealth />} />
        <Route path="/articles/aiDepressive" element={<AiDepressive />} />
        <Route path="/articles" element={<ArticlesMain />} />
        <Route path="/articles/aiInArchitect" element={<AiInArchitect />} />
        <Route path="/articles/mlOutRails" element={<MlOutRails />} />
        <Route path="/articles/mlEcommerce" element={<MlEcommerce />} />
        <Route path="/articles/digitalHealth" element={<DigitalHealth />} />
        <Route path="/articles/aiChatbots" element={<AiChatbots />} />
        <Route path="/articles/mlRoadmap" element={<MlRoadmap />} />
        <Route path="/articles/computerVision" element={<ComputerVision />} />
        <Route path="/articles/genAi" element={<GenAi />} />
        <Route path="/articles/dataPrivacy" element={<DataPrivacy />} />

        <Route path="*" element={<NotFound />} />

        
        
        
        
      </Routes>
    </div>
  );
}

export default App;
